import CancelablePromise from 'mn-utils/CancelablePromise';
import {TCurrency, TFilter, TList, TResponse, TUUID} from '@/types';

import {apiRequest} from '../../ws';
import {get, post} from '../../http';

import {TListItem, TCreateParams, TUpdateParams} from './types';
import {getCryptoAccountsList, apiV2CryptoAccountGet} from './mock';

export function apiV2AppList(params: TFilter<TListItem, {amount_currency: TCurrency}>): Promise<TList<TListItem>> {
  const url = '/f2c/v1/console/crypto-wallet/list/';
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getCryptoAccountsList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}

export function apiV2AppGet(params: {id: TUUID}): Promise<TListItem> {
  const url = '/f2c/v1/console/app/item/' + params.id;
  if (process.env.MOCK) {
    const response = apiV2CryptoAccountGet();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url, params);
}

export function apiV2AppCreate(params: TCreateParams): Promise<TResponse> {
  const url = '/f2c/v1/console/app/create';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// Обновить информацию по банку
export function apiV2AppUpdate(params: TUpdateParams): Promise<TResponse> {
  const url = '/f2c/v1/console/app/update';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// Удалить банк
export function apiV2AppDelete(params: {id: TUUID}): Promise<TResponse> {
  const url = '/v2/console/crypto-accounts/remove';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}